import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BulkPaymentLayout from '../components/BulkPayment/BulkPaymentLayout';
import Stepper from '../components/BulkPayment/Stepper';
import UploadBulkPayExcel from '../components/BulkPayment/UploadBulkPayExcel';
import ReviewTable from '../components/BulkPayment/ReviewTable';
import ReviewPayment from '../components/BulkPayment/ReviewPayment';
import PaymentProcessing from '../components/BulkPayment/PaymentProcessing';
import SupportingDocument from '../components/BulkPayment/SupportingDocument';
import { useSelector } from 'react-redux';

const steps = ['Upload file', 'Review', 'Confirmation'];

const BulkPayment = () => {
    const clientData = useSelector(state => state.juno.clientData || null);
    const [step, setStep] = useState(1);
    const [headerContent, setHeaderContent] = useState({
        title: '',
        isBack: false,
    });
    const [parentTransactionId, setParentTransactionId] = useState(null);
    const [currentBulkPaymentId, setCurrentBulkPaymentId] = useState(null);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const imageBaseUrl = useSelector(state => state.config.image_base_url);
    const apiUrl = useSelector(state => state.config.api_url);
    const adminRole = localStorage.getItem('adminRole');
    const email = localStorage.getItem('email');

    const navigate = useNavigate();

    useEffect(() => {
        setHeaderContent({
            title: steps[step - 1],
            isBack: true,
        });

        if (!clientData) navigate('/client');
    }, [step]);

    const handleBack = () => {
        step === 1 ? navigate(-1) : setStep(prev => prev - 1);
    };

    const handleChangeBulkpaymentId = (bulkPaymentId = null, transactionId = null) => {
        setCurrentBulkPaymentId(bulkPaymentId);
        setParentTransactionId(transactionId);
    };

    return (
        clientData && (
            <div>
                <BulkPaymentLayout
                    stepper={<Stepper steps={steps} currentStep={step} />}
                    currentStep={step}
                    headerContent={headerContent}
                    handleBack={handleBack}>
                    {step === 1 && (
                        <UploadBulkPayExcel
                            handleContinue={() => setStep(2)}
                            handleChangeBulkpaymentId={handleChangeBulkpaymentId}
                            imageBaseUrl={imageBaseUrl}
                            userDetails={{ email, adminRole }}
                            clientData={{
                                ...clientData,
                                clientObjId: clientData._id,
                                accountID: clientData.accountNumber,
                            }}
                            apiUrl={apiUrl}
                        />
                    )}
                    {step === 2 && (
                        <div className="w-full justify-center md:!mx-1">
                            <ReviewPayment
                                handleContinue={selectedFiles => {
                                    setStep(3);
                                    setSelectedFiles(selectedFiles);
                                }}
                                handleBack={handleBack}
                                bulkPaymentId={currentBulkPaymentId}
                                parentTransactionId={parentTransactionId}
                                imageBaseUrl={imageBaseUrl}
                                apiUrl={apiUrl}
                            />
                        </div>
                    )}
                    {step === 3 && (
                        <div className="!w-full lg:mt-[25px]">
                            <PaymentProcessing
                                imageBaseUrl={imageBaseUrl}
                                handleNavigate={() => navigate('/client')}
                            />
                            <div className="lg:w-[95vw] w-full lg:mb-[80px] lg:mt-3 md:!mx-1">
                                {selectedFiles.length > 0 && (
                                    <SupportingDocument
                                        selectedFiles={selectedFiles}
                                        handleBack={handleBack}
                                        imageBaseUrl={imageBaseUrl}
                                    />
                                )}
                                <ReviewTable transactionId={parentTransactionId} />
                            </div>
                        </div>
                    )}
                </BulkPaymentLayout>
            </div>
        )
    );
};

export default BulkPayment;
